import {OrderEvent} from "../models/events/OrderEvent";
import {OrderEventType} from "../models/events/OrderEventType";
import {OrderFormatService} from "./format/OrderFormatService";
import {OrderViewModel} from "../models/OrderViewModel";
import {OrderEventStore} from "../store/event/OrderEventStore";
import {LowPriorityNotificationService} from "../../notifications/services/popup/LowPriorityNotificationService";
import {HighPriorityNotificationService} from "../../notifications/services/popup/HighPriorityNotificationService";
import {PlacedOrdersStore} from "../store/placed/PlacedOrdersStore";
import {isUserEvent} from "./util/OrderEventUtil";
import {IFilterService} from "angular";

export class OrderStatusService {

    public static readonly id = "orderStatusService";
    private readonly translateFilter: (value: string) => string;

    /** @ngInject */
    public constructor(private readonly orderEventStore: OrderEventStore,
                       private readonly lowPriorityNotificationService: LowPriorityNotificationService,
                       private readonly highPriorityNotificationService: HighPriorityNotificationService,
                       private readonly orderFormatService: OrderFormatService,
                       private readonly placedOrdersStore: PlacedOrdersStore,
                       $filter: IFilterService) {
        this.translateFilter = $filter("translate");
    }

    public start() {
        this.orderEventStore
            .events()
            .withLatestFrom(this.placedOrdersStore.placed)
            .filter(([event, placed]) => isUserEvent(event, placed))
            .map(([event]) => event)
            .subscribe((event) => this.onEvent(event));
    }

    private onEvent(event: OrderEvent) {
        switch (event.type) {
            case OrderEventType.CREATED:
                this.orderCreated(event.order);
                break;
            case OrderEventType.UPDATED:
                this.orderUpdated(event.order);
                break;
            case OrderEventType.COMPLETED:
                this.orderComplete(event.order);
                break;
            case OrderEventType.CLOSED:
                break;
            default:
                throw Error(`Unknown event type ${event.type}`);
        }
    }

    private async orderCreated(model: OrderViewModel) {
        const orderDescription = await this.orderFormatService.format(model);
        const title = this.translateFilter("order.ORDER_PLACED");
        this.lowPriorityNotificationService.success(title, orderDescription);
    }

    private orderUpdated(order: OrderViewModel) {
    }

    private async orderComplete(model: OrderViewModel) {
        if (model.isFilled) {
            const orderDescription = await this.orderFormatService.format(model);
            const title = this.translateFilter("order.ORDER_COMPLETED");
            this.highPriorityNotificationService.success(title, orderDescription);
        } else if (model.isCancelled) {
            const orderDescription = await this.orderFormatService.format(model);
            const message = `${orderDescription}`;
            const title = this.translateFilter("order.ORDER_CANCELLED");
            this.highPriorityNotificationService.error(title, message);
        }
    }
}
